<script setup lang="ts">
import PandaUIReleasesView from '@/components/admin/views/PandaUIReleasesView.vue'
</script>

<template>
  <PandaUIReleasesView />
</template>
